<div class="grid-container" [ngClass]="{'sidebar-minimized': sidebarMinimized, 'user-unauthorized': !userAuth()}">

  <div class="header" [ngClass]="{'header-none': !userAuth()}">

    <app-header></app-header>

  </div>

  <div class="sidebar" [ngClass]="{'minimized': sidebarMinimized, 'sidebar-none': !userAuth()}">

    <app-sidebar-nav></app-sidebar-nav>

  </div>

  <div class="content">

    <router-outlet></router-outlet>

  </div>

</div>
